const translation = {
  title: 'آزمون بازیابی',
  desc: 'آزمون اثرگذاری دانش بر اساس متن پرسش داده شده.',
  dateTimeFormat: 'MM/DD/YYYY hh:mm A',
  recents: 'اخیرها',
  table: {
    header: {
      source: 'منبع',
      text: 'متن',
      time: 'زمان',
    },
  },
  input: {
    title: 'متن منبع',
    placeholder: 'لطفاً یک متن وارد کنید، یک جمله کوتاه خبری توصیه می‌شود.',
    countWarning: 'تا ۲۰۰ کاراکتر.',
    indexWarning: 'فقط دانش با کیفیت بالا.',
    testing: 'در حال آزمون',
  },
  hit: {
    title: 'پاراگراف‌های بازیابی',
    emptyTip: 'نتایج آزمون بازیابی اینجا نمایش داده می‌شوند',
  },
  noRecentTip: 'اینجا نتیجه پرسش اخیر وجود ندارد',
  viewChart: 'مشاهده نمودار بُرداری',
  settingTitle: 'تنظیمات بازیابی',
  viewDetail: 'نمایش جزئیات',
  records: 'سوابق',
  keyword: 'کليدواژه',
  hitChunks: '{{num}} را بزنید تکه های فرزند',
  chunkDetail: 'جزئیات تکه',
  open: 'باز',
}

export default translation
